import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export const MediaBoxIcon = (props) => {
  const { className, src, alt, ...others } = props;
  const cls = classNames({
    "weui-media-box__thumb": true
  }, className);

  return <img className={ cls } src={ src } alt={ alt } { ...others } />;
};

export const MediaBoxTitle = (props) => {
  const { children, className, ...others } = props;
  const cls = classNames({
    "weui-media-box__title": true
  }, className);

  return <strong aria-hidden="true" className={ cls } { ...others }>{ children }</strong>;
};

export const MediaBoxDesc = (props) => {
  const { children, className, ...others } = props;
  const cls = classNames({
    "weui-media-box__desc": true
  }, className);

  return <p aria-hidden="true" className={ cls } { ...others }>{ children }</p>;
};

export const MediaBoxInfo = (props) => {
  const { children, className, infos, ...others } = props;
  const cls = classNames({
    "weui-media-box__info": true
  }, className);

  return <ul aria-hidden="true" className={ cls } { ...others }>
    {
      infos && infos.length > 0
        ? infos.map((i, idx) =>
          <MediaBoxInfoItem key={ idx } extra={ i.startsWith("|") }>
            { i.startsWith("|") ? i.substring(1) : i }
          </MediaBoxInfoItem>
        )
        : children
    }
  </ul>;
};

export const MediaBoxInfoItem = (props) => {
  const { children, className, extra, ...others } = props;
  const cls = classNames({
    "weui-media-box__info__meta": true,
    "weui-media-box__info__meta_extra": extra
  }, className);

  return <li aria-hidden="true" className={ cls } { ...others }>{ children }</li>;
};

export const MediaBoxHeader = (props) => {
  const { children, className, ...others } = props;
  const cls = classNames({
    "weui-media-box__hd": true
  }, className);

  return <div aria-hidden="true" className={ cls } { ...others }>{ children }</div>;
};

export const MediaBoxBody = (props) => {
  const { children, className, ...others } = props;
  const cls = classNames({
    "weui-media-box__bd": true
  }, className);

  return <div aria-hidden="true" className={ cls } { ...others }>{ children }</div>;
};

export class MediaBox extends PureComponent {
  render() {
    const { children, className, component, appMsg, text, small, ...others } = this.props;
    const cls = classNames({
      "weui-media-box": true,
      "weui-media-box_appmsg": appMsg,
      "weui-media-box_small-appmsg": small,
      "weui-media-box_text": text
    }, className);

    const CellComponent = component ?? "div";

    return (
      <CellComponent className={ cls } { ...others }>{ children }</CellComponent>
    );
  }
}

export class MediaBoxText extends PureComponent {
  render() {
    const { title, desc, infos, ...others } = this.props;

    return (
      <MediaBox text { ...others }>
        <MediaBoxTitle>{ title }</MediaBoxTitle>
        <MediaBoxDesc>{ desc }</MediaBoxDesc>
        {
          infos && infos.length > 0 && <MediaBoxInfo infos={ infos } />
        }
      </MediaBox>
    );
  }
}

export class MediaBoxAppMsg extends PureComponent {
  render() {
    const { title, desc, icon, component, ...others } = this.props;

    return (
      <MediaBox appMsg component={ component ?? "a" } { ...others }>
        {
          icon &&
            <MediaBoxHeader>
              <MediaBoxIcon src={ icon } />
            </MediaBoxHeader>
        }
        <MediaBoxBody>
          <MediaBoxTitle>{ title }</MediaBoxTitle>
          <MediaBoxDesc>{ desc }</MediaBoxDesc>
        </MediaBoxBody>
      </MediaBox>
    );
  }
}
